import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated } from './adminIndex';

const AdminRoute = ({
  component: Component,
  privilegeKey,
  bypassPrivilegeCheck = false,
  ...rest
}) => {
  const { admin } = isAuthenticated();

  const isPrivileged = () => {
    if (!admin) return false;
    if (admin.isSuperAdmin) return true;

    const privileges = admin.privileges || {};

    if (Array.isArray(privilegeKey)) {
      return privilegeKey.every(key => privileges[key] === true || privileges[key] === 'true');
    }

    if (typeof privilegeKey === 'string') {
      return privileges[privilegeKey] === true || privileges[privilegeKey] === 'true';
    }

    return true;
  };

  return (
    <Route
      {...rest}
      render={props => {
        if (!admin) {
          return <Redirect to={{ pathname: "/adminsignin", state: { from: props.location } }} />;
        }

        if (!privilegeKey) {
          return <Component {...props} />;
        }

        // Check if admin has at least one privilege
        const hasAnyPrivilege =
          admin.isSuperAdmin ||
          (admin.privileges &&
            typeof admin.privileges === 'object' &&
            Object.values(admin.privileges).some(val => val === true || val === 'true'));

        if (!hasAnyPrivilege && !bypassPrivilegeCheck) {
          return <Redirect to="/admin/dashboard" />;
        }

        if (privilegeKey && !isPrivileged()) {
          return <Redirect to="/admin/dashboard" />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default AdminRoute;